<template>
  <v-container fluid :class="settingsContainerClass">
    <v-slide-y-transition mode="out-in">
        <router-view/>
    </v-slide-y-transition>
    <ModalContainer :modalKey="'addTaskTemplateGroup'" :width="'small'">
      <QuickModal
        :title="'Task Template Group'"
        :placeholder="'Group Name'"
        @cancelled="onModalCancelled"
        @ok="onNewTaskTemplateGroupCreated"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'taskTemplateForm'" :width="'450'">
      <TaskTemplateModal
        @done="onTaskTemplateFormDone"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <!--  -->
  </v-container>
</template>

<script>

import {childOfOrEqualDetails} from './router/routes';
import * as I18nActionTypes from "../../store/app/i18n/types";
import { createModalMixin } from '@/dt-plugins/modal/modal.mixin';
import QuickModal from "@plugins/quickmodal/quickmodal";
import TaskTemplateModal from "../settings/components/settings-plugins/task-template-modal.vue"
//import { createFields } from "../../../../plugins/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";
import { closeModalRoute } from '../../dt-plugins/modal/modal.mixin';
import { taskService } from '../tasks/services/tasks.service';
// import AddGroup from '@/dt-plugins/groups/add-group';
// import ContactsGroupsAddNew from './components/contact-group/contacts-groups-add-modal';
import { SettingsStoreNamespace as storeNS } from "../settings/store";
import { mapKeyToAction } from "../../store/global";
import * as ActionTypes from "../settings/store/types";
export default {
  components: {
    // AddGroup,
    // ContactsGroupsAddNew
    QuickModal,
    ModalContainer,
    TaskTemplateModal
  },
  mixins: [
    // createModalMixin('addGroup'),
    // createModalMixin('contactsGroupsAddNew')
    createModalMixin("addTaskTemplateGroup"),
    createModalMixin("taskTemplateForm"),
  ],
  mounted: function () {
    this.$store.dispatch(I18nActionTypes.INSERT_SYSTEM_LANGUAGE_SECTION, [
      "settings",'invoice','main'
    ]);
  },
  computed: {
    settingsContainerClass: function() {
      return {
        'dt-module': true,
        'inactive': childOfOrEqualDetails(this.$route)
      };
    }
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.TaskTemplateGroup.INSERT.SINGLE,
      ActionTypes.TaskTemplate.INSERT.SINGLE
    ]),

    onModalCancelled: function () {
      closeModalRoute(this);
    },
    onNewTaskTemplateGroupCreated:async function (value) {
     
     const table = this.$route.query.external_table
     const res = await taskService.taskTemplateGroupAddUpdate(value,table)

     console.log(res,"PPPPPPPPP",value,this.$route.query.external_table)

     const settingsKey = 'taskSettingsData'//table=='booking'?'bookingSettingsData':'labelSettingsData';

      await this[ActionTypes.TaskTemplateGroup.INSERT.SINGLE]({settingsKey:settingsKey,external_table:table});
      this.onModalCancelled();
    },
    onTaskTemplateFormDone: async function ({ mode, task_template }) {
      const external_table = this.$route.query.external_table
      console.log("POIIII",external_table)
      const settingsKey = 'taskSettingsData'//external_table=='booking'?'bookingSettingsData':'labelSettingsData';
      await this[ActionTypes.TaskTemplate.INSERT.SINGLE]({task_template:{...task_template , external_table:external_table },settingsKey:settingsKey });
     // this.onModalCancelled();
    },
    
    // MARK: Methods
  }
}
</script>

